import { Tooltip } from 'antd';
import React from 'react';
import { createGlobalStyle } from 'styled-components';
const GlobalNoTransparency = createGlobalStyle `
  body {
    .ant-tooltip-inner {
      background-color: #000;
    }
  }
`;
// AntD makes it very tricky to style the tooltip inner due to rendering it at the body level, not
// using the parent component. This turns the triggering component into the popup container (instead
// of a div in the body).
export const SolidTooltip = props => (React.createElement(Tooltip, { ...props },
    React.createElement(GlobalNoTransparency, null),
    props.children));
